import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { BackArrowIcon } from "../../../utils/FontIcon";
import { useLogin } from '../../../context/LoginContext';
import AssignCourseOnRole from "./AssignCourseOnRole";
import AssignCourseOnGroup from "./AssignCourseOnGroup";

export default function AssignCourse() {
    const { user } = useLogin();
    const [assignType, setAssignType] = useState('group');
    const navigate = useNavigate();
    const handelGotoDashboard = () => {
        navigate('/home');
    }
    return (
        <Col lg={12} className="add-video-bg" style={{ minHeight: '80vh' }}>
            <Row>
                <Col lg={6} xs={12} md={10}>
                    <h4 className="mb-0 fw-bold">Course Assignment</h4>
                    <div className="mb-2 ms-1 small fw-semibold text-secondary">(Simplify and assign with ease)</div>
                </Col>
                <Col lg={6} xs={12} md={2} className="text-end">
                    <Button variant="outline-dark" onClick={handelGotoDashboard} title="Go to dashboard"><BackArrowIcon /> Go to dashboard</Button>
                </Col>
            </Row>
            <Row>
                <div className="add-video-container">
                    <Form className="mb-2 mt-1">
                            <Form.Check
                                inline
                                label="Groupwise Assignment"
                                name="group1"
                                type='radio'
                                checked={assignType === 'group'}
                                onChange={() => {
                                    setAssignType('group');
                                }}
                            />
                            <Form.Check
                                inline
                                label="Rolewise Assignment"
                                name="group2"
                                checked={assignType === 'role'}
                                type='radio'
                                onChange={() => {
                                    setAssignType('role');
                                }}
                            />
                    </Form>
                    {assignType === 'group' ?
                    <AssignCourseOnGroup />:<AssignCourseOnRole />}
                </div>
            </Row>

        </Col>
    );
}
